// Copyright ©️ 2026 eVolve MEP, LLC

import type { Shipment } from '@evolvemep/api-ts';
import { Flex } from '@mantine/core';

import {
  ShipmentWorkflowActionButton,
  type ShipmentWorkflowActionButtonProps,
} from 'modules/Shop/Shipments/ShipmentDetail/ShipmentWorkflowActionButton';
import { ShipmentWorkflowGridMenu } from 'modules/Shop/Shipments/ShipmentDetail/ShipmentWorkflowGridMenu';

type Props = {
  shipment: Shipment;
  onShipmentUpdated: () => void;
  onShipmentDeleted: () => void;
};

const shipmentActionButtons: Pick<ShipmentWorkflowActionButtonProps, 'label' | 'action' | 'contextAction'>[] = [
  {
    label: 'Ready to ship',
    action: 'markReady',
    contextAction: 'markReady',
  },
  {
    label: 'Mark shipped',
    action: 'markShipped',
    contextAction: 'markShipped',
  },
  {
    label: 'Mark delivered',
    action: 'markDelivered',
    contextAction: 'markDelivered',
  },
];

export const ShipmentWorkflowButtons = ({ shipment, onShipmentUpdated, onShipmentDeleted }: Props) => (
  <Flex gap="xs" align="center">
    {shipmentActionButtons.map((buttonProps) => (
      <ShipmentWorkflowActionButton
        key={buttonProps.action}
        {...buttonProps}
        shipment={shipment}
        onShipmentUpdated={onShipmentUpdated}
      />
    ))}
    <ShipmentWorkflowGridMenu
      shipment={shipment}
      onShipmentUpdated={onShipmentUpdated}
      onShipmentDeleted={onShipmentDeleted}
    />
  </Flex>
);
